import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";

import PouchStorage from "~/libs/storage/pouch";

import annotations from "./annotations";
import bookmarks from "./bookmarks";
import uistate from "./uistate";
import notes from "./notes";
import presentationMarkers from "./presentationMarkers";
import dlsUserMaterials from "./dlsUserMaterials";

const configuration = {
  key: "uistate",
  keyPrefix: "",
  storage: PouchStorage,
  blacklist: ["isVisible"],
  serialize: false,
  debug: true,
  deserialize: false
  // stateReconciler: hardSet
};

const reducer = combineReducers({
  annotations,
  bookmarks,
  notes,
  presentationMarkers,
  dlsUserMaterials,
  uistate: persistReducer(configuration, uistate)
});

export default reducer;
